<!-- 消息模块 -->
<template>
  <div class="allNews">
    <div class="tabs">
      <div class="titleBox">
        <div class="message__title">待办事项</div>
        <div class="role-auth-title">
          <el-radio-group v-model="category" size="small" @change="chooseType">
            <el-radio-button :label="1">
              我的批注
            </el-radio-button>
            <el-radio-button :label="0">
              项目消息
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="right">
        <el-form inline label-width="80px">
          <el-form-item>
            <el-input v-model="content" placeholder="请输入标题或描述查询" size="small" clearable @input="getList(1)" >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="getList(1)" ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="body">
      <div class="top">
        <el-button size="mini" class="handleRead" plain @click="selectAll" type="primary">全选</el-button >
        <el-button :disabled="selectionList.length == 0" size="mini" plain class="handleRead" @click="isReadBtn" >标记为已读</el-button >
        <el-button v-if="deleNews" :disabled="selectionList.length==0" size="mini" class="handleRead" type="danger" plain @click="deleteBtn" >删除</el-button >
      </div>
      <div class="table">
        <el-table v-loading="loading" key="isRead" ref="messageData" :data="messageData" element-loading-text="拼命加载中" style="width: 100%" height="100%" @row-click="openDetailChange" @selection-change="handleSelectionChange" >
          <template slot="empty">
            <img :src="zanwu" alt=""/>
            <p style="font-size: 16px; color: #000; margin-top: 36px"> 暂无消息 </p>
          </template>
          <el-table-column type="selection" width="55px" align="center"></el-table-column>
          <el-table-column prop="userName" label="发送人" width="100">
            <template slot-scope="scope">
              {{ scope.row.messageInfoVo.senderName }}
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template slot-scope="scope">
              <div style="display: flex;">
                <div style="color: #323232; font-size: 14px"> {{ scope.row.messageInfoVo.title }} </div>
                <div v-if="scope.row.messageInfoVo.category == 0" class="turnRouter" @click.stop="turnRouterPrj(scope.row)" > 点击进入项目 </div>
                <div v-if="scope.row.messageInfoVo.category == 1" class="turnRouter" @click.stop="turnRouterModel(scope.row)" > 点击进入问题 </div>
                <div v-if="scope.row.messageInfoVo.category == 2" class="turnRouter" @click.stop="turnRouterprocess(scope.row)" > 点击进入流程 </div>
                <div v-if="scope.row.messageInfoVo.category == 3&&(scope.row.messageInfoVo.type==102||scope.row.messageInfoVo.type==103)" class="turnRouter" @click.stop="turnRouterSystem(scope.row)" > 点击查看详情 </div>
                <div v-if="scope.row.messageInfoVo.category == 3&&scope.row.messageInfoVo.type==104" class="turnRouter" @click.stop="turnRouterFile(scope.row)" > 点击查看文件 </div>
                <div v-if="scope.row.messageInfoVo.category == 3&&scope.row.messageInfoVo.type==105" class="turnRouter" @click.stop="turnRouterFile(scope.row)" > 点击查看文件夹 </div>
                <div v-if="scope.row.messageInfoVo.category == 4" class="turnRouter" @click.stop="turnRouterTask(scope.row)" > 点击查看任务 </div>
              </div>
              <div class="problem">
                <span v-if="scope.row.messageInfoVo.category == 1"></span>
                <span v-else-if="scope.row.messageInfoVo.category == 0">描述：</span>
                <span v-else-if="scope.row.messageInfoVo.category == 3"></span>
                <span v-else-if="scope.row.messageInfoVo.category == 2||scope.row.messageInfoVo.category == 4">标题：</span>
                {{ scope.row.messageInfoVo.content }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nodeName" label="时间" width="200" header-align="center">
            <template slot-scope="scope">
              <div class="font">
                <div :title="scope.row.messageInfoVo.createDate" class="grayFont" >
                  {{ scope.row.messageInfoVo.createDate }}
                </div>
                <div v-if="scope.row.messageInfoVo.prjName" :title="scope.row.messageInfoVo.prjName" class="grayFont1">
                  来自：{{ scope.row.messageInfoVo.prjName }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="page.totalCount > 0" class="page">
        <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData" class="el-pagination"></page>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/CommonDP/service/message-service";
import flowService from "@/CommonDP/service/flow-service";
import requestprj from "@/CommonDP/service/integratedModel-service";
import page from "@/CommonDP/components/paging";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
export default {
  inject: ['reload'],
  props: {
    prjId: {
      require: true
    }
  },
  components:{page},
  data() {
    return {
      zanwu: require('@/CommonDP/assets/暂无数据.png'),
      page:{
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      },
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      messageData: [],
      category: 1,
      content: "",
      selectionList: [],
      selectDataList: [],
      selectAllFlag: false,
      projectlist: [],
      loading: true,
      deleNews: checkPermission(':mainMgNews:dele')
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
  },
  mounted() {
    this.getList(1);
    this.getprojectlist();
  },
  methods: {
    addNewsNumKey(){
      this.$store.dispatch("setNewsNumKey", new Date().getTime());
    },
    async getprojectlist() {
      if (this.enterpriseId) {
        const params={
          enterpriseId:this.enterpriseId,
          prjName:"",
          prjCode:"",
          prjType:"",
          prjLevel:""
        };
        const res = await requestprj.queryPrj(params);
        this.projectlist = res.data;
      }
    },
    // 跳转项目
    async turnRouterPrj(item) {
      const id = item.messageInfoVo.messageId;
      await this.openDetail(id);
      const obj = { prjId: item.messageInfoVo.prjId, prjName: item.messageInfoVo.prjName, prjCode: item.messageInfoVo.prjCode };
      this.$store.dispatch("updatePrj", obj);
      if (item.messageInfoVo.prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除")
      } else if (item.messageInfoVo.prjIsDelete === "0") {
        const prjId = item.messageInfoVo.prjId;
        sessionStorage.setItem("prePrj", JSON.stringify(prjId));
        this.$router.push({name: "projectHome"});
      }
    },
    // 跳转问题
    async turnRouterModel(item) {
      const id = item.messageInfoVo.messageId;
      await this.openDetail(id);
      var objNew = JSON.parse(item.messageInfoVo.extraParams);
      if (item.messageInfoVo.prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除")
      } else if (item.messageInfoVo.prjIsDelete === "0") {
        // 查看问题消息是否删除
        const {data} = await request.drawingAnnotation(objNew.questionId)
        const { fileList, fileTypeInt, questionId } = data;
        let folderId, fileVersion, fileType;
        if (fileList.length > 1) {
          folderId = fileList.map((ele) => ele.fileId).join(",");
          fileVersion = fileList.map((ele) => ele.fileVersion).join(",");
          fileType = Number(fileTypeInt);
        } else {
          folderId = fileList[0].fileId;
          fileVersion = fileList[0].fileVersion;
          fileType = Number(fileTypeInt);
        }
        const params = {
          status: "2",
          fileId: folderId,
          versionId: fileVersion,
          parentId: "",
          questionId,
          fileType
        };
        filePreviewV1(params);
        // if (result.result === '0') {
        //   const obj = { prjId: item.messageInfoVo.prjId, prjName: item.messageInfoVo.prjName, prjCode: item.messageInfoVo.prjCode };
        //   this.$store.dispatch("updatePrj", obj);
        //   const prjId = item.messageInfoVo.prjId;
        //   sessionStorage.setItem("prePrj", JSON.stringify(prjId));
        //   if(item.messageInfoVo.type===106||item.messageInfoVo.type===101){
        //     this.$router.push({name:"issueMg",query:{issueType:"0"}});
        //   }else if(item.messageInfoVo.type===107){
        //     this.$router.push({name:"issueMg",query:{issueType:"1"}});
        //   }else if(item.messageInfoVo.type===108){
        //     this.$router.push({name:"issueMg",query:{issueType:"2"}});
        //   }
          
        // }
      }
    },

    // 跳转流程
    async turnRouterprocess(item) {
      const { messageId, groupId, prjId, prjIsDelete } = item.messageInfoVo;
      var obj = JSON.parse(item.messageInfoVo.extraParams);
      await this.openDetail(messageId);
      this.$store.dispatch("updatePrj", obj);
      if (prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除")
      } else if (prjIsDelete === "0") {
        if (obj.receiveUserType === 2) {
          // 审批人
          const res = await flowService.queryUserStatus(obj.flowId);
          if (!res.data.status) {
            this.$router.push({ name: "myApproval", query: { id: obj.flowId, prjId: prjId, groupId: groupId ,title: "pending",status:1}});
          } else {
            this.$router.push({
              path: "/myFinishedDetail",
              query: { id: obj.flowId, prjId: prjId, groupId: groupId }
            });
          }
        } else if (obj.receiveUserType === 1) {
          // 创建人
          this.$router.push({
            name: "establishDetail",
            query: { id: obj.flowId, status: obj.flowStatus, prjId: prjId, groupId: groupId, title: "muSubmit", }
          });
        } else if (obj.receiveUserType === 3) {
          // 抄送人
          this.$router.push({
            path: '/myCopysendDetail',
            query: { id: obj.flowId, prjId: prjId, groupId: groupId }
          });
        }
      }
    },

    // 跳转到人员管理
    async turnRouterSystem(item) {
      const extraParams = JSON.parse(item.messageInfoVo.extraParams);
      const id = item.messageInfoVo.messageId;
      await this.openDetail(id);
      if (item.messageInfoVo.type === 102&&extraParams.isExternal===1) {
        this.$router.push({path:'/morepersonInfo',query:{type:'1'}});
      }else if(item.messageInfoVo.type === 102&&extraParams.isExternal===0) {
        this.$router.push({path:'/morepersonInfo',query:{type:'0'}});
      } else if (item.messageInfoVo.type === 103&&extraParams.isExternal===1 ) {
        //成员管理
        this.$router.push("/supperManage");
      } else if (item.messageInfoVo.type === 103&&extraParams.isExternal===0) {
        //内部人员
        this.$router.push("/personInfo");
      }
    },

    // 跳转到任务
    async turnRouterTask(item) {
      const id = item.messageInfoVo.messageId;
      await this.openDetail(id);
      var objNew = JSON.parse(item.messageInfoVo.extraParams);
      if (item.messageInfoVo.prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除")
      } else if (item.messageInfoVo.prjIsDelete === "0") {
        // 判断当前任务是否删除
        const result = await request.prjqueryTaskNew(objNew.taskId)
        if (result.result === '0') {
          const obj = { prjId: item.messageInfoVo.prjId, prjName: item.messageInfoVo.prjName, prjCode: item.messageInfoVo.prjCode };
          this.$store.dispatch("updatePrj", obj);
          const prjId = item.messageInfoVo.prjId;
          sessionStorage.setItem("prePrj", JSON.stringify(prjId));
          this.$router.push({name:"taskList"});
        }
      }
    },

    // 跳转到我的收藏
    async turnRouterFile(item) {
      const id = item.messageInfoVo.messageId;
      await this.openDetail(id);
      this.$router.push({name:"mycollection"});
    },
    // 点击变已读
    async openDetailChange(item) {
      if (item.messageInfoVo.category === 0) {
        this.turnRouterPrj(item)
      } else if (item.messageInfoVo.category === 1) {
        this.turnRouterModel(item)
      } else if (item.messageInfoVo.category === 2) {
        this.turnRouterprocess(item)
      } else if (item.messageInfoVo.category === 3 && (item.messageInfoVo.type === 102 || item.messageInfoVo.type === 103)) {
        this.turnRouterSystem(item)
      } else if (item.messageInfoVo.category === 4) {
        this.turnRouterTask(item)
      } else if (item.messageInfoVo.category === 3 && (item.messageInfoVo.type === 104 || item.messageInfoVo.type === 105)) {
        this.turnRouterFile(item)
      }
    },
    async openDetail(id) {
      const res = await request.messageRead([id]);
      if (res.result === "0") {
        this.addNewsNumKey()
        this.$message.success("已读该条消息");
      }
      await this.getList(1);
      this.$store.dispatch("unreadNum");
    },
    chooseType(key) {
      this.messageData = [];
      this.loading = true;
      this.category = key;
      this.getList(1);
    },
    fetchData(val) {
      this.$nextTick(() => {
        this.$refs.messageData.bodyWrapper.scrollTop = 0
      })
      this.getList(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1)
    },
    async getList(index) {
      const {  prjId, content, enterpriseId ,category,page:{pageSize} } = this;
      const params = { isRead:0, prjId, content, pageNum: index, pageSize, enterpriseId, category };
			const { data, totalCount, pageIndex } = await request.messageList( params );
      this.messageData = data;
      this.page.totalCount = totalCount;
      this.page.pageNum = pageIndex;
      this.selectAllFlag = false;
      this.loading = false;
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    async isReadBtn() {
      if (!this.selectAllFlag) {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await request.messageRead(list);
      } else {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await request.messageRead(list);
      }
      this.addNewsNumKey();
      await this.getList(1);
      this.$store.dispatch("unreadNum");
    },
    selectAll() {
      if (!this.selectAllFlag) {
        this.messageData.map((item) => {
          this.$refs.messageData.toggleRowSelection(item, true);
        });
        this.selectDataList = this.messageData.map((item) => {
          return item.id;
        });
        this.selectAllFlag = true;
      } else {
        this.messageData.map((item) => {
          this.$refs.messageData.toggleRowSelection(item, false);
        });
        this.selectAllFlag = false;
        this.selectDataList = [];
      }
    },
    async deleteBtn() {
      if (!this.selectAllFlag) {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await this.$confirm(`您确定要删除当前${list.length}项`, "警告", { type: "warning" });
        await request.messageDelete(list);
        this.addNewsNumKey();
      } else {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await this.$confirm(`您确定要删除当前${list.length}项`, "警告", { type: "warning" });
        await request.messageDelete(list);
        this.addNewsNumKey();
      }
      await this.getList(1);
      this.$store.dispatch("unreadNum");
    }
  }
};
</script>

<style lang="scss" scoped>
.allNews {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .tabs {
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ebefff;
    padding-left: 10px;
    /deep/.el-badge__content {
      z-index: 1;
    }
    .titleBox{
      display: flex;
      align-items: center;
    }
    .message__title{
      height: 30px;
      font-size: 16px;
      vertical-align: middle;
      font-weight: bold;
      line-height: 30px;
      display: flex;
      align-items: center;
      &::before{
        content: ' ';
        display: inline-block;
        border-radius: 6px;
        margin-right: 3px;
        line-height: 30px;
        background-color: #3370FF;
        width: 3px;
        height: 16px;
        vertical-align: middle;
      }
    }
    .role-auth-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-left: 10px;
    }
    .right {
      margin-top: 5px;
    }
  }
  .body {
    height: calc(100% - 60px);
    overflow: hidden;
    background-color: #fff;
    .top {
      height: 40px;
      .el-radio-group {
        padding-left: 20px;
        margin-top: 25px;
        float: left;
      }
      .handleRead {
        float: left;
        margin-left: 10px;
        margin-top: 6px;
      }
    }
    .table {
      height: calc(100% - 78px);
      padding: 0px 10px 10px;
      overflow: auto;
      .problem {
        font-size: 12px;
        color: #666666;
      }
      .turnRouter {
        cursor: pointer;
        color: #5587F0;
        font-size: 12px;
        background: #5587f01f;
        border-radius: 50px;
        padding: 1px 12px;
        margin-left: 6px;

      }
      .font {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
      }
      .grayFont {
        color: #8e959b;
        user-select: none;
        font-size: 15px;
      }
      .grayFont1 {
        font-size: 12px;
        color: #5584ff;
      }
    }
    .page {
      width: 98%;
      height: 45px;
      margin: 5px auto;
      .el-pagination {
        float: right;
      }
    }
  }
}
</style>